import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api/admin`;

const getAuthHeaders = () => {
  const token = localStorage.getItem('adminToken');
  return {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};

export const adminLogin = async (username, password) => {
  try {
    const response = await axios.post(`${API}/login`, { username, password });
    
    if (response.data.success) {
      localStorage.setItem('adminToken', response.data.token);
      localStorage.setItem('adminUser', JSON.stringify(response.data.admin));
      return {
        success: true,
        admin: response.data.admin,
        token: response.data.token
      };
    }
    return { success: false, message: 'Login failed' };
  } catch (error) {
    return {
      success: false,
      message: error.response?.data?.detail || 'Login failed'
    };
  }
};

export const adminLogout = () => {
  localStorage.removeItem('adminToken');
  localStorage.removeItem('adminUser');
};

export const getStoredAdmin = () => {
  const adminStr = localStorage.getItem('adminUser');
  return adminStr ? JSON.parse(adminStr) : null;
};

export const getStoredToken = () => {
  return localStorage.getItem('adminToken');
};

export const createAdmin = async (adminData) => {
  try {
    const response = await axios.post(`${API}/create-admin`, adminData, {
      headers: getAuthHeaders()
    });
    return { success: true, data: response.data };
  } catch (error) {
    let errorMessage = 'Failed to create admin';
    
    // Handle different error response formats
    if (error.response?.data) {
      const errorData = error.response.data;
      
      // Handle FastAPI validation errors
      if (errorData.detail) {
        if (Array.isArray(errorData.detail)) {
          // Pydantic validation errors
          errorMessage = errorData.detail.map(err => {
            const field = err.loc ? err.loc[err.loc.length - 1] : 'Field';
            return `${field}: ${err.msg}`;
          }).join(', ');
        } else if (typeof errorData.detail === 'string') {
          errorMessage = errorData.detail;
        } else {
          errorMessage = JSON.stringify(errorData.detail);
        }
      } else if (errorData.message) {
        errorMessage = errorData.message;
      }
    } else if (error.message) {
      errorMessage = error.message;
    }
    
    return {
      success: false,
      message: errorMessage
    };
  }
};
